<pmv-fieldset [header]="header" *ngIf="header; else nofieldset">
  <ng-container *ngTemplateOutlet="checkbox"></ng-container>
</pmv-fieldset>

<ng-template #nofieldset>
  <ng-container *ngTemplateOutlet="checkbox"></ng-container>
</ng-template>

<ng-template #checkbox>
  <label *ngFor="let option of _options" class="checkbox-inline">
    <input type="checkbox" [value]="option.value" (click)="selectOption(option)" [disabled]="disabled" /> {{ option.label }}
  </label>
</ng-template>



// WEBPACK FOOTER //
// ./src/deps/pmv-common/pmv-common.d.ts.ɵv.html